(function($) {
    function ChooseCategory() {
        this.noOfSelectedCategory = 0;
        this.categoryWrap = $('.categories-wrap');

        this.init();
        this.addListeners();
    }

    ChooseCategory.prototype = {
        init: function() {
            let self = this;

            $.each(self.categoryWrap.find('.category-item-name'), function() {
                if ($(this).find('[type=checkbox]').is(":checked"))
                    self.noOfSelectedCategory++;
            });
        },

        addListeners: function () {
            let self = this;

            self.categoryWrap
                .find('.category-item-name')
                .click(function () {
                    let checkbox = $(this).find('[type=checkbox]');

                    if (!checkbox.is(':checked')) {
                        if (self.isReachedLimitation())
                            return false;

                        self.noOfSelectedCategory++;
                    } else
                        self.noOfSelectedCategory--;

                    $(this).toggleClass('active');
                    checkbox.prop('checked', !checkbox.is(':checked'));
                });

            self.categoryWrap
                .find('button[type=submit]')
                .click(function (event) {
                    event.preventDefault();

                    if (!self.noOfSelectedCategory) {
                        alert("You should select at least 1 category.");
                        return false;
                    }

                    self.categoryWrap
                        .find('form')
                        .submit();
                });
        },

        isReachedLimitation: function() {
            let self = this,
                totalChecked = 0;

            $.each(self.categoryWrap.find('.category-item-name'), function() {
                if ($(this).find('[type=checkbox]').is(':checked'))
                    totalChecked++;
            });

            if (totalChecked >= 9) {
                alert("You only can save up to 9 categories.");

                return true;
            } else
                return false;
        }
    }

    $(document).ready(function () {
        new ChooseCategory();
    })
}) (jQuery)
